import { render, staticRenderFns } from "./CompilationFolderModal.vue?vue&type=template&id=4ef062c0&scoped=true"
import script from "./CompilationFolderModal.vue?vue&type=script&lang=js"
export * from "./CompilationFolderModal.vue?vue&type=script&lang=js"
import style0 from "./CompilationFolderModal.vue?vue&type=style&index=0&id=4ef062c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef062c0",
  null
  
)

export default component.exports